import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Empresa } from 'src/app/models/configuracion/empresa.model';
import { HistorialNotificacion } from 'src/app/models/notificacion/historial_notificacion.model';
import { JobNotificacion } from 'src/app/models/notificacion/job.model';
import { WhatsappTemplate } from 'src/app/models/notificacion/whatsapp_template.model';
import { ProcesoReporte } from 'src/app/pages/base/proceso-reporte';
import { EmpresaService } from 'src/app/services/configuracion/empresa.service';
import { ContactoService } from 'src/app/services/notificacion/contacto.service';
import { HistorialNotificacionService } from 'src/app/services/notificacion/historial_notificacion.service';
import { JobService } from 'src/app/services/notificacion/job.service';
import { WhatsappTemplateService } from 'src/app/services/notificacion/whatsapp_template.service';
import { Global } from 'src/global';
import { Subscription } from 'rxjs';
import { conservarSeleccionados } from './destinatarios-seleccionados.util';

interface ITemplateVariableFieldOption {
    label: string;
    value: string;
}

interface IWhatsappDestinatario {
    numero: string;
    data: Record<string, any>;
}

interface IWhatsappConfigEstado {
    cargado: boolean;
    permitido: boolean;
    mensaje: string;
}

interface ITemplateEstadoMeta {
    label: string;
    icon: string;
    tagClass: string;
}

interface ITemplateVariableControl {
    /** Posición del hueco, corrida entre encabezado, cuerpo y botones. */
    variable: number;
    control: FormControl;
    /** Qué es ese hueco, en palabras del usuario. */
    etiqueta: string;
    /**
     * El hueco lo llena la plantilla, no un campo de datos.
     *
     * Hoy solo pasa con el archivo del encabezado: ocupa una posición aunque no
     * lleve ninguna variable, y el archivo sale de la plantilla. El usuario no
     * elige nada, pero TIENE que verlo: si no, cree que el cuerpo arranca en la
     * posición 1 y mapea todo corrido.
     */
    ocupadoPorPlantilla: boolean;
}

@Component({
  selector: 'app-envio-mensaje',
  templateUrl: './envio-mensaje.component.html',
  styleUrls: ['./envio-mensaje.component.scss']
})
export class EnvioMensajeComponent  extends ProcesoReporte implements OnInit {


    historialNotificacion: HistorialNotificacion;
    uploadedFiles: any[] = [];
    selectFiles: any[] = [];
    numeros: any[] = [];
    isMobile: boolean;
    timer: any;
    numerosSeleccionados:  any[] = [];
    @ViewChild('textareaRef') textareaRef: ElementRef;
    cols: number = 120;

    tipoCooperativa = Empresa.COOPERATIVA;
    CABAL_Y_PROCARD = 3;

    // Tipos de origen - SOLO 2 opciones: Contactos (BD) o Excel
    tiposOrigen = [
        { valor: 'contactos', nombre: 'Lista de Contactos', descripcion: 'Elegir de mi base de datos', icono: 'pi pi-database' },
        { valor: 'excel', nombre: 'Archivo Excel/CSV', descripcion: 'Subir archivo con destinatarios', icono: 'pi pi-file-excel' }
    ];

    // Variables para Excel
    excelData: any[] = [];
    excelPreview: any[] = [];
    excelHeaders: string[] = [];
    excelStats = { total: 0, validos: 0, invalidos: 0 };
    archivoExcelSubido: boolean = false;
    cargaMasivaId: number | null = null;

    // Variables para progreso del job
    jobId: number | null = null;
    jobStatus: any = null;
    mostrarProgreso: boolean = false;
    intervaloProgreso: any = null;
    envioEnProceso: boolean = false;

    // Variables para origen seleccionado
    origenSeleccionado: string = 'contactos';

    private readonly CONTACTOS_TEMPLATE_FIELDS: ITemplateVariableFieldOption[] = [
        { label: 'Nombre', value: 'nombre' },
        { label: 'Documento', value: 'documento' },
        { label: 'Celular', value: 'celular' },
        { label: 'Correo', value: 'correo' },
    ];

    private readonly TEMPLATE_FIELD_KEYS_IGNORADAS = new Set(['label', 'description']);

    contactosMedalla = [
        { valor: 1, nombre: 'Cabal'},
        { valor: 2, nombre: 'Procard'},
        { valor: 3, nombre: 'Cabal y Procard' },
        { valor: 4, nombre: 'Otros' },
        { valor: 5, nombre: 'Todos' }
    ]

    tipos = [
        { valor: 1, nombre: 'SMS'},
        { valor: 2, nombre: 'WHATSAPP'},
    ]

    TIPO_SMS = HistorialNotificacion.TIPO_SMS;
    TIPO_WHATSAPP = HistorialNotificacion.TIPO_WHATSAPP;
    remainingCharacters: number = 150;
    /**
     * Marcador que el backend entiende: esa posición la llena el archivo de la
     * plantilla, no un campo de datos. Ver `SENTINELA_IMAGEN` en
     * `meta-template-variables.ts`.
     */
    private static readonly SENTINELA_IMAGEN = '__imagen__';

    /** Formatos de encabezado que llevan archivo y ocupan una posición. */
    private static readonly FORMATOS_MULTIMEDIA = ['IMAGE', 'VIDEO', 'DOCUMENT'];

    subirImagen: boolean = false;
    
    // Plantillas WhatsApp disponibles para seleccionar
    whatsappTemplates: any[] = [];
    whatsappTemplateSeleccionada: any = null;
    flujoHabilitado: boolean = false;
    whatsappReactivationTemplateId: number | null = null;
    templateVariablesDetectadas: number[] = [];
    templateVariableControls: ITemplateVariableControl[] = [];
    templateVariableRenderHabilitado: boolean = true;
    templateFieldsOptions: ITemplateVariableFieldOption[] = [];
    whatsappConfigEstado: IWhatsappConfigEstado = {
        cargado: false,
        permitido: false,
        mensaje: 'Verificando configuración de remitente WhatsApp...',
    };

    constructor(
        private fb: FormBuilder,
        private contactoService: ContactoService,
        private service: HistorialNotificacionService,
        private jobService: JobService,
        public messageService: MessageService,
        private router: Router,
        private breadcrumbService: AppBreadcrumbService,
        private empresaService: EmpresaService,
        private whatsappTemplateService: WhatsappTemplateService,
        private cdr: ChangeDetectorRef
    ) { 
        super();
        this.breadcrumbService.setItems([ { label: 'Notificacion'},{ label: 'Enviar Mensaje' } ]);
        this.isMobile = window.innerWidth <= 768; 
        this.historialNotificacion = new HistorialNotificacion();
    }

    ngOnInit(): void {
        this.iniciarComponente();
    }

    ngOnDestroy(): void {
        // Limpiar intervalo al destruir componente
        if (this.intervaloProgreso) {
            clearInterval(this.intervaloProgreso);
        }
    }

    private crearOpcionNumero(contacto: Record<string, any>) {
        // Buscar número en diferentes formatos posibles (celular, telefono, teléfono, phone)
        const numero = contacto.celular || contacto.telefono || contacto.teléfono || contacto.phone || contacto.numero || '';
        const nombre = contacto.nombre || contacto.nombrecompleto || contacto.name || '';
        
        // Mostrar "nombre - numero" para identificar mejor los contactos
        const label = nombre ? `${nombre} - ${numero}` : numero;
        
        return {
            ...contacto,
            label: label,
            numero: numero,
            celular: numero, // Necesario para optionValue="celular"
            nombre: nombre,
            description: nombre
        };
    }

    async iniciarComponente(){
        this.uploadedFiles = [];
        this.selectFiles = [];
        this.subirImagen = false;
        this.excelData = [];
        this.excelPreview = [];
        this.excelHeaders = [];
        this.excelStats = { total: 0, validos: 0, invalidos: 0 };
        this.archivoExcelSubido = false;
        this.cargaMasivaId = null;
        this.jobId = null;
        this.jobStatus = null;
        this.mostrarProgreso = false;
        this.origenSeleccionado = 'contactos';
        this.templateVariablesDetectadas = [];
        this.templateVariableControls = [];
        this.templateVariableRenderHabilitado = true;
        this.templateFieldsOptions = [];
        
        await this.crearFormulario();
        await this.sincronizarEmpresaSeleccionada();

        this.refrescarOpcionesCamposTemplate();
    }

    private getTemplateControlName(variable: number): string {
        return `template_var_${variable}`;
    }

    /**
     * Cuántas POSICIONES de parámetro necesita un texto.
     *
     * Tiene que dar EXACTAMENTE lo mismo que `contarVariables` del backend
     * (`meta-template-variables.ts`), que es quien arma el envío real. Si las dos
     * cuentas difieren, el operador mapea una lista de huecos distinta de la que
     * se usa al enviar y los datos salen corridos.
     *
     * No es la cantidad de apariciones: `{{1}}` usado dos veces es UNA posición.
     * Con numeración salteada se cuentan las posiciones hasta la más alta.
     */
    private contarPosicionesTemplate(texto: string): number {
        const encontrados = String(texto || '').match(/{{\s*[^}]*?\s*}}/g) || [];

        if (encontrados.length === 0) {
            return 0;
        }

        const indices = encontrados
            .map((bruto) => Number(bruto.replace(/[^0-9]/g, '')))
            .filter((n) => Number.isFinite(n) && n > 0);

        if (indices.length === 0) {
            return new Set(encontrados.map((b) => b.trim())).size;
        }

        return Math.max(...indices);
    }

    /**
     * Arma la lista de huecos de la plantilla, en el orden en que los numera Meta.
     *
     * ENCABEZADO -> CUERPO -> BOTONES, corrido. Antes esta lista salía solo del
     * texto del cuerpo: una plantilla con archivo en el encabezado corría todas
     * las posiciones en uno y el operador no tenía forma de saberlo.
     */
    private construirHuecosTemplate(template: Record<string, any> | null): Array<{ etiqueta: string; ocupado: boolean }> {
        const huecos: Array<{ etiqueta: string; ocupado: boolean }> = [];

        if (!template) {
            return huecos;
        }

        const formato = String(template['header_format'] || '').toUpperCase();

        // 1. ENCABEZADO. El archivo ocupa una posición aunque no lleve variables.
        if (EnvioMensajeComponent.FORMATOS_MULTIMEDIA.includes(formato)) {
            huecos.push({ etiqueta: 'Archivo del encabezado', ocupado: true });
        } else if (formato === 'TEXT') {
            const cantidad = this.contarPosicionesTemplate(template['header_text']);
            for (let i = 1; i <= cantidad; i += 1) {
                huecos.push({ etiqueta: `Encabezado, dato ${i}`, ocupado: false });
            }
        }

        // 2. CUERPO.
        const enCuerpo = this.contarPosicionesTemplate(template['mensaje']);
        for (let i = 1; i <= enCuerpo; i += 1) {
            huecos.push({ etiqueta: `Mensaje {{${i}}}`, ocupado: false });
        }

        // 3. BOTONES con enlace, en orden de declaración.
        const botones = Array.isArray(template['buttons']) ? template['buttons'] : [];
        botones.forEach((boton: Record<string, any>) => {
            if (String(boton?.['tipo'] || '').toUpperCase() !== 'URL') {
                return;
            }

            const cantidad = this.contarPosicionesTemplate(boton?.['url']);
            for (let i = 1; i <= cantidad; i += 1) {
                huecos.push({ etiqueta: `Enlace del botón "${boton?.['texto'] || ''}"`, ocupado: false });
            }
        });

        return huecos;
    }

    private resetTemplateVariableControls() {
        if (!this.formGroup) {
            return;
        }

        this.templateVariablesDetectadas = [];
        this.templateVariableControls = [];

        const controlesDinamicos = Object.keys(this.formGroup.controls)
            .filter((key) => key.startsWith('template_var_'));

        controlesDinamicos.forEach((key) => this.formGroup.removeControl(key));
        this.formGroup.updateValueAndValidity({ emitEvent: false });
    }

    private configurarVariablesTemplate(template: Record<string, any> | null) {
        if (!this.formGroup) {
            return;
        }

        // Transición atómica: congelar render y limpiar estado anterior.
        this.templateVariableRenderHabilitado = false;
        this.resetTemplateVariableControls();

        const huecos = this.construirHuecosTemplate(template);

        if (huecos.length === 0) {
            this.templateVariableRenderHabilitado = true;
            return;
        }

        const controles: ITemplateVariableControl[] = [];
        huecos.forEach((hueco, indice) => {
            const variable = indice + 1;

            // El hueco del archivo va con su valor puesto y deshabilitado: el
            // backend lo espera con este marcador y el usuario no elige nada.
            const control = hueco.ocupado
                ? new FormControl({ value: EnvioMensajeComponent.SENTINELA_IMAGEN, disabled: true })
                : new FormControl(null, Validators.required);

            this.formGroup.addControl(this.getTemplateControlName(variable), control);
            controles.push({
                variable,
                control,
                etiqueta: hueco.etiqueta,
                ocupadoPorPlantilla: hueco.ocupado,
            });
        });

        this.templateVariablesDetectadas = controles
            .filter((item) => !item.ocupadoPorPlantilla)
            .map((item) => item.variable);
        this.templateVariableControls = controles;

        this.formGroup.updateValueAndValidity({ emitEvent: false });
        this.templateVariableRenderHabilitado = true;
    }

    private mapearCampoTemplateDefecto(variable: number): string | null {
        const preferidos: Record<number, string> = {
            1: 'nombre',
            2: 'monto',
            3: 'vencimiento',
            4: 'documento',
        };
        const preferido = preferidos[variable];

        if (!preferido) {
            return null;
        }

        const existe = this.templateFieldsOptions.some((option) => option.value === preferido);
        return existe ? preferido : null;
    }

    private setTemplateMappingsDefault() {
        this.templateVariablesDetectadas.forEach((variable) => {
            const control = this.templateVariableControls.find((item) => item.variable === variable)?.control;
            if (control) {
                const valorActual = control.value;
                const valorActualEsValido = this.templateFieldsOptions.some((option) => option.value === valorActual);
                if (valorActual && valorActualEsValido) {
                    return;
                }

                control.setValue(this.mapearCampoTemplateDefecto(variable));
            }
        });
    }

    private limpiarMapeosTemplateInvalidos() {
        if (!this.formGroup || this.templateVariablesDetectadas.length === 0) {
            return;
        }

        const camposPermitidos = new Set(this.templateFieldsOptions.map((option) => option.value));

        this.templateVariablesDetectadas.forEach((variable) => {
            const control = this.templateVariableControls.find((item) => item.variable === variable)?.control;
            const valorActual = control?.value;

            if (valorActual && !camposPermitidos.has(valorActual)) {
                control?.setValue(null);
            }
        });
    }

    private normalizarFilasExcel(rows: unknown): Record<string, unknown>[] {
        if (!Array.isArray(rows)) {
            return [];
        }

        return rows.filter((row): row is Record<string, unknown> => !!row && typeof row === 'object' && !Array.isArray(row));
    }

    private construirHeadersEstables(rows: Record<string, unknown>[]): string[] {
        const headers = new Set<string>();

        rows.forEach((row) => {
            Object.keys(row).forEach((key) => {
                if (key && !this.TEMPLATE_FIELD_KEYS_IGNORADAS.has(key)) {
                    headers.add(key);
                }
            });
        });

        return Array.from(headers);
    }

    private normalizarHeadersEstables(headers: string[]): string[] {
        const headersVistos = new Set<string>();
        const headersOrdenados: string[] = [];

        headers.forEach((header) => {
            if (typeof header !== 'string') {
                return;
            }

            const headerNormalizado = header.trim();
            if (!headerNormalizado || headersVistos.has(headerNormalizado)) {
                return;
            }

            headersVistos.add(headerNormalizado);
            headersOrdenados.push(headerNormalizado);
        });

        return headersOrdenados;
    }

    private extraerRespuestaCargaExcel(resp: Record<string, any>): {
        contactos: Record<string, unknown>[];
        preview: Record<string, unknown>[];
        headers: string[];
        total: number;
        validos: number;
        invalidos: number;
        cargaId: number | null;
    } {
        const payload = resp?.resp || {};
        const contactos = this.normalizarFilasExcel(payload?.contactos);
        const preview = this.normalizarFilasExcel(payload?.preview);

        const headersBackend = Array.isArray(payload?.headers)
            ? this.normalizarHeadersEstables(
                payload.headers.filter((header: unknown): header is string => typeof header === 'string' && !!header)
            )
            : [];

        const headers = headersBackend.length > 0
            ? headersBackend
            : this.construirHeadersEstables(contactos.length > 0 ? contactos : preview);

        return {
            contactos,
            preview,
            headers,
            total: Number(payload?.total || contactos.length || preview.length || 0),
            validos: Number(payload?.validos || contactos.length || preview.length || 0),
            invalidos: Number(payload?.invalidos || 0),
            cargaId: payload?.carga_id ? Number(payload.carga_id) : null,
        };
    }

    private obtenerHeadersExcel(): string[] {
        if (this.excelHeaders.length > 0) {
            return [...this.excelHeaders];
        }

        const source = this.excelData.length > 0 ? this.excelData : this.excelPreview;
        if (!Array.isArray(source) || source.length === 0) {
            return [];
        }

        return this.construirHeadersEstables(this.normalizarFilasExcel(source));
    }

    /**
     * Recorre TODOS los controles, no solo los que el usuario elige.
     *
     * El hueco del archivo del encabezado está deshabilitado pero tiene que
     * viajar igual: es lo que le dice al backend que esa posición está ocupada
     * por la plantilla. Si se omitiera, el backend correría el resto.
     */
    private getTemplateVariableMappings(): Record<string, string> {
        const mappings: Record<string, string> = {};

        this.templateVariableControls.forEach((item) => {
            const value = item.control?.value;
            if (value) {
                mappings[String(item.variable)] = value;
            }
        });

        return mappings;
    }

    private obtenerDescripcionEnvio(value: Record<string, any>): string {
        const descripcionFormulario = String(value?.descripcion || '').trim();

        if (descripcionFormulario) {
            return descripcionFormulario;
        }

        if (value?.tipo !== HistorialNotificacion.TIPO_WHATSAPP) {
            return descripcionFormulario;
        }

        const nombreTemplate = String(
            value?.nombre_whatsapp_template || this.whatsappTemplateSeleccionada?.nombre || ''
        ).trim();

        if (nombreTemplate) {
            return nombreTemplate;
        }

        const descripcionTemplate = String(
            this.whatsappTemplateSeleccionada?.descripcion || this.whatsappTemplateSeleccionada?.mensaje || ''
        ).trim();

        if (descripcionTemplate) {
            return descripcionTemplate;
        }

        const nombreCampania = String(value?.nombre || '').trim();

        if (nombreCampania) {
            return nombreCampania;
        }

        return 'Envío WhatsApp masivo';
    }

    private generarIdempotencyKey(idEmpresa: number): string {
        const randomPart = Math.random().toString(36).slice(2, 12);
        return `whatsapp-masivo-${idEmpresa}-${Date.now()}-${randomPart}`;
    }

    getTemplateVariablesPendientes(): number[] {
        const mappings = this.getTemplateVariableMappings();
        return this.templateVariablesDetectadas.filter((variable) => !mappings[String(variable)]);
    }

    getTemplateVariablesPendientesTexto(): string {
        return this.getTemplateVariablesPendientes().map((variable) => `{{${variable}}}`).join(', ');
    }

    isTemplateMappingIncompleto(): boolean {
        if (!this.formGroup || this.formGroup.get('tipo')?.value !== HistorialNotificacion.TIPO_WHATSAPP) {
            return false;
        }

        if (this.templateVariablesDetectadas.length === 0) {
            return false;
        }

        return this.getTemplateVariablesPendientes().length > 0;
    }

    private refrescarOpcionesCamposTemplate() {
        if (this.origenSeleccionado === 'excel') {
            this.templateFieldsOptions = this.obtenerHeadersExcel().map((header) => ({
                label: header,
                value: header,
            }));
        } else {
            this.templateFieldsOptions = [...this.CONTACTOS_TEMPLATE_FIELDS];
        }

        this.limpiarMapeosTemplateInvalidos();

        if (this.templateVariablesDetectadas.length > 0) {
            this.setTemplateMappingsDefault();
        }
    }

    private obtenerDataDestinatarioSeleccionado(): IWhatsappDestinatario[] {
        const numerosSeleccionados = this.formGroup.get('numerosSeleccionados')?.value || [];
        if (!numerosSeleccionados.length) {
            return [];
        }

        return this.numeros
            .filter((contacto: any) => numerosSeleccionados.includes(contacto.celular))
            .map((contacto: any) => ({
                numero: contacto.celular,
                data: contacto,
            }));
    }

    private limpiarImagenAdjunta(): void {
        this.uploadedFiles = [];
        this.selectFiles = [];
        this.formGroup?.get('imagenes')?.setValue(null);
    }

    async crearFormulario() {
        const esSuperusuario = Boolean(this.currentUser?.superusuario);
        const idEmpresa = esSuperusuario ? null : (this.currentUser?.id_empresa || null);
        const nombreEmpresa = esSuperusuario ? null : (this.currentUser?.nombre_empresa || null);
        const tipoEmpresa = esSuperusuario ? null : (this.currentUser?.empresa?.tipo || null);
        
        this.formGroup = this.fb.group({
            id_empresa: [idEmpresa, Validators.required],
            nombre_empresa: [nombreEmpresa],
            tipo: [this.TIPO_SMS],
            tipo_empresa: [tipoEmpresa],
            nombre: [null, Validators.required],
            descripcion: [null, Validators.required],
            id_whatsapp_template: [null],
            nombre_whatsapp_template: [null],
            contactos_medalla: [this.CABAL_Y_PROCARD],
            numerosSeleccionados:[null],
            imagenes: [null],
            origen: ['contactos'],
        })
    }

    /**
     * Cambio de origen - solo 2 opciones: contactos o excel
     */
    async onOrigenChange() {
        const origen = this.formGroup.get('origen')?.value;
        this.origenSeleccionado = origen;
        
        if (origen === 'excel') {
            // Limpiar números cuando selecciona excel
            this.numeros = [];
            this.numerosSeleccionados = [];
            this.excelData = [];
            this.excelPreview = [];
            this.excelHeaders = [];
            this.excelStats = { total: 0, validos: 0, invalidos: 0 };
            this.archivoExcelSubido = false;
            this.cargaMasivaId = null;
            this.refrescarOpcionesCamposTemplate();
        } else {
            // Contactos - limpiar excel y cargar contactos
            this.excelData = [];
            this.excelPreview = [];
            this.excelHeaders = [];
            this.excelStats = { total: 0, validos: 0, invalidos: 0 };
            this.archivoExcelSubido = false;
            this.cargaMasivaId = null;
            await this.cargarContactos();
            return;
        }
    }

    async onOrigenSeleccion(origen: 'contactos' | 'excel') {
        if (this.formGroup.get('origen')?.value === origen) {
            return;
        }

        this.formGroup.get('origen')?.setValue(origen);
        await this.onOrigenChange();
    }

    /**
     * Cargar contactos usando el endpoint filtrar
     */
    async cargarContactos() {
        try {
            const idEmpresa = this.getEmpresaSeleccionadaId();
            
            if (!idEmpresa) {
                this.numeros = [];
                this.refrescarOpcionesCamposTemplate();
                return;
            }

            if (this.esEmpresaSeleccionadaCooperativa()) {
                await this.cargarContactosCabalProcard(this.formGroup?.value?.contactos_medalla || this.CABAL_Y_PROCARD);
                return;
            }
            
            const body = {
                id_empresa: idEmpresa,
                filtro_contacto: '',
                cooperativa: false,
                contactos_medalla: this.formGroup?.value?.contactos_medalla || 3
            };
            
            const res = await this.contactoService.filtarContacto(body);
            
            if (res.ok && res.resp && res.resp.length > 0) {
                const todosLosContactos = res.resp.flat();
                
                this.numeros = todosLosContactos.map((contacto: any) => this.crearOpcionNumero(contacto));
            } else {
                this.numeros = [];
            }

            this.refrescarOpcionesCamposTemplate();
        } catch (error) {
            console.error('Error cargando contactos:', error);
            this.numeros = [];
            this.refrescarOpcionesCamposTemplate();
        }
    }

    /**
     * Manejar archivo Excel subido
     */
    async onExcelSelect(event: any) {
        try {
            const selectedFile = event.files[0];
            if (!selectedFile) return;

            const idEmpresa = this.getEmpresaSeleccionadaId();
            const nombreEmpresa = this.getNombreEmpresaSeleccionada();

            if (!idEmpresa || !nombreEmpresa) {
                this.messageService.add({
                    severity: 'warn',
                    summary: 'Empresa requerida',
                    detail: 'Seleccioná una empresa antes de subir el archivo.'
                });
                return;
            }

            const base64 = await this.blobToBase64(selectedFile);
            
            const body = {
                id_empresa: idEmpresa,
                nombre_empresa: nombreEmpresa,
                archivo_base64: base64,
                nombre_archivo: selectedFile.name,
                id_creado_por: this.currentUser.id
            };

            this.loading = true;
            const resp = await this.service.subirArchivoExcel(body);
            this.loading = false;

            if (resp.ok) {
                const cargaExcel = this.extraerRespuestaCargaExcel(resp);

                this.excelData = cargaExcel.contactos.length > 0 ? cargaExcel.contactos : cargaExcel.preview;
                this.excelPreview = cargaExcel.preview.length > 0 ? cargaExcel.preview : this.excelData.slice(0, 5);
                this.excelHeaders = cargaExcel.headers;
                this.excelStats = {
                    total: cargaExcel.total,
                    validos: cargaExcel.validos,
                    invalidos: cargaExcel.invalidos
                };
                this.cargaMasivaId = cargaExcel.cargaId;
                this.archivoExcelSubido = true;

                // Convertir a formato de números (para WhatsApp necesitamos teléfono)
                this.numeros = this.excelData.map((contacto: any) => this.crearOpcionNumero(contacto));
                this.refrescarOpcionesCamposTemplate();

                this.messageService.add({
                    severity: 'success',
                    summary: 'Archivo cargado',
                    detail: `${this.excelStats.validos} contactos válidos de ${this.excelStats.total} total`
                });
            } else {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error en archivo',
                    detail: resp.msg || 'El archivo debe tener una columna de teléfono o correo'
                });
                this.onExcelClear();
            }

        } catch (error: any) {
            this.loading = false;
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.message || 'Error al procesar archivo'
            });
        }
    }

    /**
     * Limpiar archivo Excel
     */
    onExcelClear() {
        this.excelData = [];
        this.excelPreview = [];
        this.excelHeaders = [];
        this.excelStats = { total: 0, validos: 0, invalidos: 0 };
        this.archivoExcelSubido = false;
        this.cargaMasivaId = null;
        this.numeros = [];
        this.refrescarOpcionesCamposTemplate();
    }

    /**
     * Iniciar polling de progreso del job
     */
    private iniciarProgresoJob(jobId: number, idEmpresa: number) {
        this.jobId = jobId;
        this.mostrarProgreso = true;
        this.jobStatus = { estado: 'pendiente', procesados: 0, total_registros: 0, porcentaje: 0 };

        this.intervaloProgreso = setInterval(async () => {
            try {
                const resp = await this.jobService.getStatus(jobId, idEmpresa);
                if (resp.ok) {
                    this.jobStatus = resp.resp;
                    this.cdr.detectChanges();

                    // Si el job terminó, detener polling
                    if (this.jobStatus.estado === 'completado' || this.jobStatus.estado === 'fallido') {
                        clearInterval(this.intervaloProgreso);
                        
                        if (this.jobStatus.estado === 'completado') {
                            this.messageService.add({
                                severity: 'success',
                                summary: 'Envío completado',
                                detail: `${this.jobStatus.procesados} mensajes enviados`
                            });
                        } else {
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Envío fallido',
                                detail: this.jobStatus.error_mensaje || 'Error en el procesamiento'
                            });
                        }
                    }
                }
            } catch (error) {
                console.error('Error consultando estado del job:', error);
            }
        }, 5000); // Consultar cada 5 segundos
    }
    
    async onTipoEnvio() {
        const value = this.formGroup.getRawValue();
        if ( value.tipo === HistorialNotificacion.TIPO_WHATSAPP ) {
            this.limpiarImagenAdjunta();
            this.subirImagen = false;

            const whatsappPermitido = await this.validarCanalWhatsappEnFront(true);
            if (!whatsappPermitido) {
                this.formGroup.get('tipo')?.setValue(HistorialNotificacion.TIPO_SMS);
                await this.onTipoEnvio();
                return;
            }

            this.formGroup.get('id_whatsapp_template')?.setValidators(Validators.required);
            this.formGroup.get('id_whatsapp_template')?.updateValueAndValidity();
            this.formGroup.get('nombre_whatsapp_template')?.setValidators(Validators.required);
            this.formGroup.get('nombre_whatsapp_template')?.updateValueAndValidity();
            this.formGroup.get('descripcion')?.clearValidators();
            this.formGroup.get('descripcion')?.updateValueAndValidity();
            
            // Cargar plantillas activas (aprobadas y no aprobadas)
            await this.cargarWhatsappTemplates();
        } else {
            this.formGroup.get('id_whatsapp_template')?.clearValidators();
            this.formGroup.get('id_whatsapp_template')?.updateValueAndValidity();
            this.formGroup.get('nombre_whatsapp_template')?.clearValidators();
            this.formGroup.get('nombre_whatsapp_template')?.updateValueAndValidity();
            this.formGroup.get('descripcion')?.setValidators(Validators.required);
            this.formGroup.get('descripcion')?.updateValueAndValidity();
            
            // Limpiar plantillas
            this.whatsappTemplates = [];
            this.whatsappTemplateSeleccionada = null;
            this.resetTemplateVariableControls();
        }
    }

    async onTipoSeleccion(tipo: number) {
        if (this.formGroup.get('tipo')?.value === tipo) {
            return;
        }

        this.formGroup.get('tipo')?.setValue(tipo);
        await this.onTipoEnvio();
    }

    private getEmpresaSeleccionadaId(): number {
        const idEmpresaFormulario = Number(this.formGroup?.get('id_empresa')?.value || 0);

        if (this.currentUser?.superusuario) {
            return idEmpresaFormulario;
        }

        return Number(idEmpresaFormulario || this.currentUser?.id_empresa || 0);
    }

    private getNombreEmpresaSeleccionada(): string {
        const nombreEmpresaFormulario = String(this.formGroup?.get('nombre_empresa')?.value || '').trim();

        if (this.currentUser?.superusuario) {
            return nombreEmpresaFormulario;
        }

        return nombreEmpresaFormulario || String(this.currentUser?.nombre_empresa || '').trim();
    }

    private getTipoEmpresaSeleccionada(): number {
        const tipoEmpresaFormulario = Number(this.formGroup?.get('tipo_empresa')?.value || 0);

        if (this.currentUser?.superusuario) {
            return tipoEmpresaFormulario;
        }

        return Number(tipoEmpresaFormulario || this.currentUser?.empresa?.tipo || 0);
    }

    esEmpresaSeleccionadaCooperativa(): boolean {
        return this.getTipoEmpresaSeleccionada() === this.tipoCooperativa;
    }

    private limpiarDestinatariosPorEmpresa(): void {
        this.formGroup.get('numerosSeleccionados')?.setValue([]);
        this.numerosSeleccionados = [];
        this.numeros = [];
        this.todosLosNumeros = [];
        this.onExcelClear();
    }

    private async sincronizarEmpresaSeleccionada(): Promise<void> {
        const idEmpresa = this.getEmpresaSeleccionadaId();

        this.limpiarDestinatariosPorEmpresa();
        await this.cargarEstadoWhatsappEmpresa(idEmpresa);

        if (!idEmpresa) {
            this.limpiarSeleccionWhatsappTemplate(true);
            this.refrescarOpcionesCamposTemplate();
            return;
        }

        if (this.origenSeleccionado === 'contactos') {
            await this.cargarContactos();
        }

        await this.recargarTemplatesWhatsappEmpresa(true);
    }

    private limpiarSeleccionWhatsappTemplate(limpiarDescripcion: boolean = false): void {
        this.whatsappTemplateSeleccionada = null;
        this.subirImagen = false;
        this.formGroup.get('id_whatsapp_template')?.setValue(null);
        this.formGroup.get('nombre_whatsapp_template')?.setValue(null);

        if (limpiarDescripcion) {
            this.formGroup.get('descripcion')?.setValue(null);
        }

        this.resetTemplateVariableControls();
    }

    private async recargarTemplatesWhatsappEmpresa(limpiarDescripcion: boolean = true): Promise<void> {
        if (this.formGroup?.get('tipo')?.value !== HistorialNotificacion.TIPO_WHATSAPP) {
            return;
        }

        this.limpiarSeleccionWhatsappTemplate(limpiarDescripcion);
        await this.cargarWhatsappTemplates();
    }
    
    async cargarWhatsappTemplates() {
        try {
            const idEmpresa = this.getEmpresaSeleccionadaId();

            if (!idEmpresa) {
                this.whatsappTemplates = [];
                this.limpiarSeleccionWhatsappTemplate(true);
                return;
            }

            const filtros = [
                { field: 'activo', type: 'boolean', value: true }
            ];

            const res = await this.whatsappTemplateService.listByCompany(idEmpresa, Global.SIZE_GET_ALL, filtros);

            if (res.ok) {
                this.whatsappTemplates = this.filtrarTemplatesSeleccionables(res.resp.rows || [])
                    .map((template: Record<string, any>) => ({
                        ...template,
                        estado: WhatsappTemplate.normalizarEstado(template.estado),
                    }));

                if (this.whatsappTemplateSeleccionada?.id) {
                    const templateActualizado = this.whatsappTemplates.find((template: Record<string, any>) => template.id === this.whatsappTemplateSeleccionada.id);

                    if (templateActualizado) {
                        this.whatsappTemplateSeleccionada = templateActualizado;
                    } else {
                        this.limpiarSeleccionWhatsappTemplate(true);
                    }
                }

                console.log('Plantillas cargadas:', this.whatsappTemplates);
            } else {
                console.error('Error response:', res);
                this.whatsappTemplates = [];
                this.limpiarSeleccionWhatsappTemplate(true);
            }
        } catch (error) {
            console.error('Error cargando plantillas WhatsApp:', error);
            this.whatsappTemplates = [];
            this.limpiarSeleccionWhatsappTemplate(true);
        }
    }
    
    selectWhatsappTemplate(template: any) {
        if (this.esTemplateReactivacion(template)) {
            return;
        }

        if (!this.isTemplateAprobada(template)) {
            return;
        }

        // Una plantilla puede estar aprobada en la base y todavía no existir en
        // Meta: son las de la era Twilio, que hay que recrear. Seleccionarla
        // dejaría pasar la campaña entera para que después falle en CADA
        // destinatario, con un error distinto por cada uno.
        if (!this.isTemplateEnMeta(template)) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Plantilla pendiente de recrear',
                detail: `"${template?.nombre || 'La plantilla'}" todavía no fue creada en Meta. Hay que recrearla desde la ventana de plantillas antes de usarla en una campaña.`,
                life: 8000,
            });
            return;
        }

        const templateIdSeleccionado = this.whatsappTemplateSeleccionada?.id;
        if (template?.id != null && templateIdSeleccionado === template.id) {
            return;
        }

        this.aplicarTemplateWhatsapp(template);
    }

    private aplicarTemplateWhatsapp(template: Record<string, any>) {
        if (!template || this.esTemplateReactivacion(template)) {
            return;
        }

        this.whatsappTemplateSeleccionada = template;
        this.formGroup.get('id_whatsapp_template')?.setValue(template.id);
        this.formGroup.get('nombre_whatsapp_template')?.setValue(template.nombre);
        this.formGroup.get('descripcion')?.setValue(template.mensaje);
        this.subirImagen = false;
        this.limpiarImagenAdjunta();
        // La plantilla entera, no solo el mensaje: los huecos salen del
        // encabezado, el cuerpo y los botones.
        this.configurarVariablesTemplate(template);
        this.refrescarOpcionesCamposTemplate();
        this.sincronizarFlujoConTemplate();
    }

    /**
     * El check de respuesta automática solo vive mientras la plantilla elegida
     * tenga un flujo dibujado. Al cambiar a una que no lo tiene, se apaga: una
     * campaña marcada contra una plantilla sin flujo no haría nada y ocultaría
     * que el bot no va a contestar.
     */
    private sincronizarFlujoConTemplate(): void {
        if (!this.templateTieneFlujo) {
            this.flujoHabilitado = false;
        }
    }

    get templateTieneFlujo(): boolean {
        const nodos = this.whatsappTemplateSeleccionada?.flujo_definicion?.nodos;
        return Array.isArray(nodos) && nodos.length > 0;
    }
    
    isTemplateSeleccionada(template: any): boolean {
        return this.whatsappTemplateSeleccionada?.id === template.id;
    }

    isTemplateAprobada(template: any): boolean {
        return Number(template?.estado) === WhatsappTemplate.ESTADO_APROBADO;
    }

    /**
     * La plantilla existe en Meta y se puede enviar.
     *
     * Estar aprobada en la base no alcanza: las plantillas creadas con Twilio no
     * tienen `meta_template_name` hasta que se las recrea.
     */
    isTemplateEnMeta(template: any): boolean {
        return Boolean(String(template?.meta_template_name || '').trim());
    }

    /** Aprobada pero sin recrear en Meta: se muestra deshabilitada y con el motivo. */
    isTemplatePendienteDeRecrear(template: any): boolean {
        return this.isTemplateAprobada(template) && !this.isTemplateEnMeta(template);
    }

    getTemplateEstadoMeta(template: any): ITemplateEstadoMeta {
        const estado = Number(template?.estado);

        switch (estado) {
            case WhatsappTemplate.ESTADO_APROBADO:
                return { label: 'Aprobado', icon: 'pi pi-check-circle', tagClass: 'template-tag-aprobado' };
            case WhatsappTemplate.ESTADO_RECHAZADO:
                return { label: 'Rechazado', icon: 'pi pi-times-circle', tagClass: 'template-tag-rechazado' };
            case WhatsappTemplate.ESTADO_ERROR:
                return { label: 'Error', icon: 'pi pi-exclamation-circle', tagClass: 'template-tag-error' };
            case WhatsappTemplate.ESTADO_BORRADOR:
                return { label: 'Borrador', icon: 'pi pi-pencil', tagClass: 'template-tag-borrador' };
            case WhatsappTemplate.ESTADO_PENDIENTE:
            default:
                return { label: 'Pendiente', icon: 'pi pi-clock', tagClass: 'template-tag-pendiente' };
        }
    }

    //configuracion del texto 
    calculateCols() {
        if (!this.textareaRef?.nativeElement) return;
        
        const textareaWidth = this.textareaRef.nativeElement.offsetWidth;
        const maxWidth = 400; 
        const minWidth = 200; 
        const minCols = 20; 
        const maxCols = 120;
        this.cols = Math.max( minCols, Math.min(maxCols, Math.floor(textareaWidth / maxWidth * maxCols)));
        this.cdr.detectChanges();
    }

    async onEmpresa() {
        try {
            const value = this.formGroup.value;  
            let objeto = null;
            const filtros = [
                { field: 'id', value: value.id_empresa, type: 'id' },
                
            ]
            const res = await this.empresaService.getAll( Global.SIZE_GET_ALL, { filters: filtros } );
            if ( res.ok && res.resp.count > 0 ) {
                objeto = res.resp.rows[0];
            } else {
                this.messageService.add({severity: 'info', summary: 'Empresa no encontrada', detail: ''});
            }
            await this.setEmpresa(objeto);
        } catch (error: any) {
            this.messageService.add(this.objSession);
            setTimeout( () => { this.router.navigate(this.routerLogout) }, 4000);
        }
    }

    async cargarNumeros() {
        try {
            const value = this.formGroup.value;
            const filtros = [
                { field: 'id_empresa', value: value.id_empresa, type: 'id' },
            ]
            const res = await this.contactoService.getAll( Global.SIZE_GET_ALL, { filters:filtros});
            if (res.ok && res.resp.count > 0) {
                // this.numeros = res.resp.rows;
                this.numeros = res.resp.rows.map((contacto) => this.crearOpcionNumero(contacto));
            } else {
                this.messageService.add({ severity: 'info', summary: 'Contactos no encontrados', detail: '' });
            }
            this.refrescarOpcionesCamposTemplate();
        } catch (error) {
            this.messageService.add({severity: 'error', summary: 'Error', detail: error.message });
            this.refrescarOpcionesCamposTemplate();
        }
    }

    async setEmpresa( obj: Record<string, any> ) {
        this.formGroup.get('id_empresa').setValue(obj?.id);
        this.formGroup.get('nombre_empresa').setValue(obj?.nombre);
        this.formGroup.get('tipo_empresa').setValue(obj?.tipo);
        await this.sincronizarEmpresaSeleccionada();
    }

    /**
     * E.164 completo, no solo Paraguay.
     *
     * Como Tech Provider de Meta una empresa puede tener un numero de cualquier
     * pais. La version anterior exigia `+595` y bloqueaba el envio masivo con un
     * mensaje que nombraba un pais que no aplica.
     */
    private esWhatsappRemitenteValido(remitente: string): boolean {
        return /^\+[1-9]\d{7,14}$/.test(String(remitente || '').trim());
    }

    private construirMensajeBloqueoWhatsapp(empresa: Record<string, any> | null): string {
        if (!empresa) {
            return 'No se pudo verificar la configuración de empresa. Probá nuevamente.';
        }

        const habilitado = empresa.whatsapp_remitente_habilitado !== false;
        const remitente = String(empresa.whatsapp_remitente || '').trim();
        // La vinculacion se comprueba contra las credenciales de Meta, no contra
        // las de Twilio. Una empresa migrada tiene twilio_account_sid vacio: con
        // el candado anterior, el envio masivo quedaba bloqueado para TODAS las
        // empresas migradas, pidiendoles cargar credenciales de un proveedor que
        // ya no se usa.
        const wabaId = String(empresa.waba_id || '').trim();
        const phoneNumberId = String(empresa.phone_number_id || '').trim();

        if (!habilitado) {
            return 'La empresa tiene WhatsApp deshabilitado. Activá el remitente en Configuración de Empresa.';
        }

        if (!remitente) {
            return 'La empresa no tiene remitente WhatsApp configurado. Cargalo en Configuración de Empresa.';
        }

        if (!this.esWhatsappRemitenteValido(remitente)) {
            return 'El remitente WhatsApp de la empresa es inválido. Debe estar en formato internacional E.164 (ej: +595981123456).';
        }

        if (!wabaId || !phoneNumberId) {
            return 'La empresa no está vinculada con Meta. Completá la vinculación desde Configuración de Empresa.';
        }

        return '';
    }

    private async cargarEstadoWhatsappEmpresa(idEmpresa: number): Promise<void> {
        const id = Number(idEmpresa || 0);
        if (!id) {
            this.whatsappReactivationTemplateId = null;
            this.whatsappConfigEstado = {
                cargado: true,
                permitido: false,
                mensaje: 'No hay empresa seleccionada para validar WhatsApp.',
            };
            return;
        }

        try {
            const filtros = [
                { field: 'id', value: id, type: 'id' },
            ];
            const res = await this.empresaService.getAll(Global.SIZE_GET_ALL, { filters: filtros });
            const empresa = res.ok && res?.resp?.count > 0 ? res.resp.rows[0] : null;
            this.whatsappReactivationTemplateId = empresa?.whatsapp_reactivation_template_id
                ? Number(empresa.whatsapp_reactivation_template_id)
                : null;
            const mensajeBloqueo = this.construirMensajeBloqueoWhatsapp(empresa);

            this.whatsappConfigEstado = {
                cargado: true,
                permitido: !mensajeBloqueo,
                mensaje: mensajeBloqueo,
            };
        } catch (error: any) {
            this.whatsappReactivationTemplateId = null;
            this.whatsappConfigEstado = {
                cargado: true,
                permitido: false,
                mensaje: error?.message || 'No se pudo validar la configuración de WhatsApp de la empresa.',
            };
        }
    }

    isWhatsappEnvioBloqueado(): boolean {
        return this.formGroup?.get('tipo')?.value === HistorialNotificacion.TIPO_WHATSAPP && !this.whatsappConfigEstado.permitido;
    }

    private async validarCanalWhatsappEnFront(mostrarToast: boolean): Promise<boolean> {
        const idEmpresa = this.getEmpresaSeleccionadaId();
        await this.cargarEstadoWhatsappEmpresa(idEmpresa);

        if (this.whatsappConfigEstado.permitido) {
            return true;
        }

        if (mostrarToast) {
            this.messageService.add({
                severity: 'warn',
                summary: 'WhatsApp no disponible para esta empresa',
                detail: `${this.whatsappConfigEstado.mensaje} Ir a Configuración de Empresa para corregirlo.`,
            });
        }

        return false;
    }


    async cerrarOnLista( obj?: Record<string, any> ): Promise<void> {
        await super.cerrarOnLista( obj );
        if ( this.objClassOnLista === Empresa && obj ) { await this.setEmpresa(obj) }
        if ( this.objClassOnLista === WhatsappTemplate && obj ) { await this.setWhatsappTemplate(obj) }
        this.objClassOnLista = null;
    }
    
    async onListaEmpresa() {
        await super.onLista( this.empresaService, Empresa, Empresa.NOMBRE_PLURAL );
    }

    async onListaWhatsappTemplate() {
        const idEmpresa = this.getEmpresaSeleccionadaId();
        const filtros = [
            { field: 'id_empresa', value: idEmpresa, type: 'id' },
            { field: 'estado', value: WhatsappTemplate.ESTADO_APROBADO, type: 'id' },
            { field: 'activo', value: true, type: 'boolean'}
        ]
        await super.onLista( this.whatsappTemplateService, WhatsappTemplate, WhatsappTemplate.NOMBRE_PLURAL, filtros);
    }

    async setWhatsappTemplate( obj: Record<string, any> ) {
        if (this.esTemplateReactivacion(obj)) {
            this.messageService.add({ severity: 'warn', summary: 'Template reservado', detail: 'El template de reactivación no está disponible para envíos manuales.' });
            return;
        }

        const templateIdSeleccionado = this.whatsappTemplateSeleccionada?.id;
        if (obj?.id != null && templateIdSeleccionado === obj.id) {
            return;
        }

        this.aplicarTemplateWhatsapp(obj);
    }

    private esTemplateReactivacion(template: Record<string, any> | null | undefined): boolean {
        return !!this.whatsappReactivationTemplateId
            && Number(template?.id || 0) === Number(this.whatsappReactivationTemplateId);
    }

    private filtrarTemplatesSeleccionables(templates: Record<string, any>[]): Record<string, any>[] {
        return templates.filter((template) => !this.esTemplateReactivacion(template));
    }

    trackByTemplateVariable(_index: number, item: ITemplateVariableControl): number {
        return item.variable;
    }

    private todosLosNumeros: any[] = []; // Guardar todos los números originales

    
    async onFilter(event: any) {
        this.cdr.detectChanges();
        const cooperativa = this.esEmpresaSeleccionadaCooperativa();
        const contactos_medalla = this.formGroup.value.contactos_medalla;
        const numerosSelecionado = this.formGroup.value.numerosSeleccionados || [];
        const filterValue = event.filter; 
        const idEmpresa = this.getEmpresaSeleccionadaId();

        if (!idEmpresa) {
            this.numeros = [];
            this.refrescarOpcionesCamposTemplate();
            return;
        }
        
        // Si hay filtro, buscar en el backend
        if (filterValue) {
            const filtros = { 
                id_empresa: idEmpresa, 
                filtro_contacto: filterValue,
                tipo_busqueda: 'celular'
            };
            if (cooperativa) {
                filtros['contactos_medalla'] = contactos_medalla;
            }
            filtros['cooperativa'] = cooperativa;
            
            const resp = await this.contactoService.filtarContacto(filtros);
            
            if (resp.ok && resp.resp && resp.resp.length > 0) {
                const todosLosContactos = resp.resp.flat();
                const nuevosContactos = todosLosContactos.map((contacto: any) => 
                    this.crearOpcionNumero(contacto)
                );
                
                // Filtrar duplicados y mantener seleccionados
                const nuevosSinSeleccionados = nuevosContactos.filter(
                    (elemento: any) => !numerosSelecionado.includes(elemento.celular)
                );
                
                this.numeros = [...conservarSeleccionados(numerosSelecionado, [...this.numeros, ...nuevosContactos]), ...nuevosSinSeleccionados];
                this.refrescarOpcionesCamposTemplate();
            }
        } else {
            // Sin filtro, cargar todos
            const body = {
                id_empresa: idEmpresa,
                filtro_contacto: '',
                cooperativa,
                contactos_medalla: this.formGroup?.value?.contactos_medalla || 3,
                tipo_busqueda: 'celular'
            };
            
            const res = await this.contactoService.filtarContacto(body);
            
            if (res.ok && res.resp && res.resp.length > 0) {
                const todosLosContactos = res.resp.flat();
                this.todosLosNumeros = todosLosContactos.map((contacto: any) => 
                    this.crearOpcionNumero(contacto)
                );
                
                // Mantener los seleccionados + el resto
                const seleccionados = conservarSeleccionados(numerosSelecionado, [...this.numeros, ...this.todosLosNumeros]);
                const sinSeleccionar = this.todosLosNumeros.filter(
                    (elemento: any) => !numerosSelecionado.includes(elemento.celular)
                );
                
                this.numeros = [...seleccionados, ...sinSeleccionar];
                this.refrescarOpcionesCamposTemplate();
            }
        }
    }

    async cargarContactosCabalProcard(tipo: number){
        try {
            const idEmpresa = this.getEmpresaSeleccionadaId();

            if (!idEmpresa) {
                this.numeros = [];
                this.refrescarOpcionesCamposTemplate();
                return;
            }

            const filtros =  {
                id_empresa: idEmpresa,
                tipo: tipo
            };
            const res = await this.contactoService.recuperarContactosMedalla(filtros);            
            if (res.ok && res.resp.length > 0) {
                // this.numeros = res.resp[0];
                this.numeros = res.resp[0].map((contacto) => this.crearOpcionNumero(contacto));
                this.refrescarOpcionesCamposTemplate();
            } else {
                this.messageService.add({ severity: 'info', summary: 'Contactos no encontrados', detail: '' });
            }
        } catch (error) {
            this.messageService.add({severity: 'error', summary: 'Error', detail: error.message });

        }
    }

    caracteres(event: Event): void {
        const input = event.target as HTMLTextAreaElement;
        this.remainingCharacters = 150 - input.value.length;
    }

    async onSelect(event: any) {
        const selectedFiles = event.files;
        const file = [];
        file.push(selectedFiles[0])        
        const files = [];
        this.selectFiles = file;
        
        for (let selectedFile of selectedFiles) {
            const file = await this.blobToBase64(selectedFile);
            files.push(file);
        }
        this.uploadedFiles = files;
        // console.log(files);
    }

    async blobToBase64(blob: Blob): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64String = reader.result as string;
                resolve(base64String.split(',')[1]); 
            };
            reader.onerror = () => {
                reject('Error al leer el archivo');
            };
            reader.readAsDataURL(blob);
        });
    }

    // async onRemove(event: any) {
    //     const removedFileName = event.file.name;
    //     this.uploadedFiles = this.uploadedFiles.filter((file: any) => file.name !== removedFileName);
    //     this.selectFiles = this.selectFiles.filter((file: any) => file.name !== removedFileName);
    // }

    async enviarDocumento( objeto: Record<string, any> ) {
        if ( this.uploadedFiles.length > 0 ) {
            const imagen = this.selectFiles[0]
            const resp = await this.service.postImage(objeto.id, 'notificacion', imagen, 'archivo', objeto.id_empresa, objeto.nombre_empresa)
            return resp.resp;
        }
        return null
    }

    async enviarImagenCloudinary(  datos : Record<string, any> ){
        try{
            const resp = await this.service.subirImagenCloudinary( datos )
            return resp.resp;
        }catch( error ){
            this.messageService.add({severity: 'error',summary: 'Error al guardar la imagen en el servidor externo', detail: error.message });
            this.loading = false;
        }
    }

    async onClear(){
        this.limpiarImagenAdjunta();
    }

    async onWhatsappTemplate(){
        try {
            const value = this.formGroup.value;  
            let objeto = null;
            const filtros = [
                { field: 'id_empresa', value: this.getEmpresaSeleccionadaId(), type: 'id' },
                { field: 'id', value: value.id_whatsapp_template, type: 'id' },
                { field: 'activo', value: true, type: 'boolean' },
                
            ]
            const res = await this.whatsappTemplateService.getAll( Global.SIZE_GET_ALL, { filters: filtros } );
            if ( res.ok && res.resp.count > 0 ) {
                objeto = res.resp.rows[0];
            } else {
                return this.messageService.add({severity: 'info', summary: 'Template no encontrado', detail: ''});
            }
            await this.setWhatsappTemplate(objeto);
        } catch (error: any) {
            this.messageService.add(this.objSession);
            setTimeout( () => { this.router.navigate(this.routerLogout) }, 4000);
        }
    }

    /**
     * Enviar mensaje - ahora soporta origen contactos/excel/seleccion
     */
    async enviar() {
        if (this.loading || this.envioEnProceso) {
            return;
        }

        this.envioEnProceso = true;
        this.loading = true;

        try {
            if ( this.formGroup.invalid ) {
                this.messageService.add({severity: 'error', summary: 'Formulario Inválido', detail: 'Complete los campos obligatorios'});
                await this.setInvalidControlsDetalle(this.formGroup)
                return
            }

            // Validar según origen
            const origen = this.formGroup.get('origen')?.value;
            
            if (origen === 'excel' && !this.archivoExcelSubido) {
                this.messageService.add({severity: 'error', summary: 'Archivo requerido', detail: 'Suba un archivo Excel/CSV'});
                return;
            }

            if (origen === 'seleccion' && (!this.numerosSeleccionados || this.numerosSeleccionados.length === 0)) {
                this.messageService.add({severity: 'error', summary: 'Seleccione contactos', detail: 'Seleccione al menos un contacto de la lista'});
                return;
            }

            const value = this.formGroup.getRawValue();
            const idEmpresa = this.getEmpresaSeleccionadaId();
            const nombreEmpresa = this.getNombreEmpresaSeleccionada();
            const tipoEmpresa = this.getTipoEmpresaSeleccionada();
            const descripcionEnvio = this.obtenerDescripcionEnvio(value);

            if (!idEmpresa || !nombreEmpresa) {
                this.messageService.add({severity: 'error', summary: 'Empresa requerida', detail: 'Seleccioná una empresa válida antes de enviar.'});
                return;
            }

            if (value.tipo === HistorialNotificacion.TIPO_WHATSAPP) {
                const whatsappPermitido = await this.validarCanalWhatsappEnFront(true);
                if (!whatsappPermitido) {
                    return;
                }
            }

            if (value.tipo === HistorialNotificacion.TIPO_WHATSAPP && this.templateVariablesDetectadas.length > 0) {
                const variablesPendientes = this.getTemplateVariablesPendientes();
                if (variablesPendientes.length > 0) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Mapeo incompleto',
                        detail: `Debe mapear todas las variables del template: ${variablesPendientes.map((v) => `{{${v}}`).join(', ')}`,
                    });
                    return;
                }
            }

            const obj = (await this.historialNotificacion.getFormGroup()).getRawValue();
            const idempotencyKey = this.generarIdempotencyKey(idEmpresa);
            const templateMappings = this.getTemplateVariableMappings();
            
            obj.id_empresa = idEmpresa;
            obj.nombre_empresa = nombreEmpresa;
            obj.tipo = value.tipo;
            obj.nombre = value.nombre;
            obj.descripcion = descripcionEnvio;
            obj.idempotency_key = idempotencyKey;
            obj.origen = origen;
            obj.id_whatsapp_template = value?.id_whatsapp_template;
            obj.nombre_whatsapp_template = value?.nombre_whatsapp_template;
            obj.flujo_habilitado = this.templateTieneFlujo && this.flujoHabilitado;
            obj.content_variables = JSON.stringify({
                ...templateMappings,
                idempotency_key: idempotencyKey,
            });

            // Configurar destinatarios según origen
            if (origen === 'seleccion') {
                obj.destinatario = value?.numerosSeleccionados?.join(',');
            } else if (origen === 'excel') {
                // Para excel, los destinatarios vienen del archivo parseado
                obj.destinatario = this.excelData.map((c: any) => c.telefono).join(',');
            } else {
                // contactos - el backend consultará según filtros
                obj.destinatario = '';
            }

            this.historialNotificacion.serverJson = obj;

            // 1. Guardar historial de notificación
            const resp = await this.historialNotificacion.guardar( this.service );
            
            if ( !resp.ok ) {
                this.messageService.add({severity: 'error', summary: 'Error', detail: resp.msg});
                return;
            }

            const body = resp.resp;

            // 2. Subir imagen si corresponde. WhatsApp usa la imagen configurada en la plantilla.
            if (value.tipo !== HistorialNotificacion.TIPO_WHATSAPP && this.uploadedFiles.length > 0) {
                const archivoInfo = await this.enviarDocumento( body );
                body.archivo = archivoInfo;
                
                if( this.subirImagen ){
                    const datosEnviar = {
                        nombreArchivo : archivoInfo,
                        idEmpresa : idEmpresa,
                        folderName : 'notificacion',
                        nombreEmpresa : nombreEmpresa,
                        idRegistro : resp.resp.id,
                    }
                    body.archivo = await this.enviarImagenCloudinary( datosEnviar );
                }
            }

            // 3. Crear job para procesamiento asíncrono
            // Los numeros seleccionados están en el formGroup (ya definido como 'value' arriba)
            const numerosDelFormulario: string[] = value.numerosSeleccionados || [];
            
            // Los valores del form son strings (celulares)
            const destinatariosSeleccionados: string[] = numerosDelFormulario;
            const destinatariosSeleccionadosDetalle: IWhatsappDestinatario[] = this.obtenerDataDestinatarioSeleccionado();
            
            const jobBody = {
                tipo: value.tipo === HistorialNotificacion.TIPO_WHATSAPP ? 'whatsapp' : 'sms',
                tipo_origen: origen,
                id_empresa: idEmpresa,
                nombre_empresa: nombreEmpresa,
                id_creado_por: this.currentUser.id,
                nombre: value.nombre,
                idempotency_key: idempotencyKey,
                total_registros: origen === 'excel' ? this.excelStats.validos : 
                                 destinatariosSeleccionados.length > 0 ? destinatariosSeleccionados.length : 0,
                parametros: {
                    idempotency_key: idempotencyKey,
                    id_historial_notificacion: body.id,
                    id_whatsapp_template: value.id_whatsapp_template,
                    mensaje: descripcionEnvio,
                    origen: origen,
                    carga_masiva_id: this.cargaMasivaId,
                    archivo: body.archivo || null,
                    template_variable_mappings: templateMappings,
                    template_variables_detectadas: this.templateVariablesDetectadas,
                    // Siempre pasar destinatarios si hay seleccionados
                    destinatarios: destinatariosSeleccionados,
                    destinatarios_detalle: destinatariosSeleccionadosDetalle,
                    contactos_medalla: value.contactos_medalla,
                    tipo_empresa: tipoEmpresa
                }
            };

            // Crear job
            const jobResp = await this.jobService.crearJob(jobBody);
            
            if (jobResp.ok) {
                // Iniciar polling de progreso
                this.iniciarProgresoJob(jobResp.resp.id, idEmpresa);
                
                this.messageService.add({
                    severity: 'success', 
                    summary: 'Proceso iniciado', 
                    detail: `Job #${jobResp.resp.id} creado. Puede ver el progreso abajo.`
                });

                // Resetear formulario pero mantener vista de progreso
                this.formGroup.get('nombre')?.setValue(null);
                this.formGroup.get('descripcion')?.setValue(null);
                this.numerosSeleccionados = [];
            } else {
                this.messageService.add({severity: 'error', summary: 'Error', detail: jobResp.msg});
            }

        } catch (error: any) {
            this.messageService.add({severity: 'error', summary: 'Error', detail: error.message });
        } finally {
            this.loading = false;
            this.envioEnProceso = false;
        }
    }
}
